export const fireDurations = {
  THIRTY: 30,
  SIXTY: 60,
  NINETY: 90,
  HUNDRED_TWENTY: 120
};

export const attackSides = {
  ONE: 'one',
  MORE: 'more'
};


export const fireParams = {
  DURATION: 'duration',
  SIDE: 'side'
};


export class Fire {

  constructor(
    duration = fireDurations.THIRTY,
    side = attackSides.ONE
  ) {
    this[fireParams.DURATION] = duration;
    this[fireParams.SIDE] = side;
  }

}



// WEBPACK FOOTER //
// ./src/views/Loads/GeneralLoading/DesignLoading/misc/fire.class.js